/**
 * StanceChip: a care manager's stance on new clients (Open, Talk to Me or
 * Not Open) as a Chip in that stance's colour, ink on each. Its only
 * content is the stance's label, and it carries the stance itself in
 * data-stance. Assign's rows and the board's read-only cell render it.
 */

import { type ComponentPropsWithRef, type ReactNode } from 'react';
import { Chip, type ChipVariant } from '@/components/primitives/Chip';
import { STATED_AVAILABILITY_LABEL, type NewClientStance } from '@/lib/capacity';

const STANCE_VARIANT: Record<NewClientStance, ChipVariant> = {
  open: 'stance-open',
  talk_to_me: 'stance-talk-to-me',
  not_open: 'stance-not-open',
};

export interface StanceChipProps extends Omit<ComponentPropsWithRef<'span'>, 'children'> {
  stance: NewClientStance;
}

export function StanceChip({ stance, ...spanProps }: StanceChipProps): ReactNode {
  return (
    <Chip variant={STANCE_VARIANT[stance]} data-stance={stance} {...spanProps}>
      {STATED_AVAILABILITY_LABEL[stance]}
    </Chip>
  );
}
